// extracted by mini-css-extract-plugin
export default {"DesktopLayout":"DesktopLayout_DesktopLayout__O+Plt","rightBar":"DesktopLayout_rightBar__kJGUH","personalisationSidebar":"DesktopLayout_personalisationSidebar__Q4j8U"};